import {
  Box,
  Container,
  Grid,
  GridItem,
  Heading,
  Text,
} from '@chakra-ui/react'
import { useRouter } from 'next/router'
import PayLeafNavbar from '../../components/PayLeafNavbar'

export const ALL_GUIDES = [{
  title: 'Register as a merchant',
  subtitle: 'Learn how to setup a phantom wallet and register on PayLeaf',
  bgColor: '#fbb800',
  mt: [0, 0, '40px'],
  href: '/guides/introduction-for-merchants',
  colStart: [1, 'auto', 3]
}, {
  title: 'Off-ramp funds to your bank',
  subtitle: 'Learn how to get your funds into your bank account from your phantom wallet',
  bgColor: '#a375ff',
  mt: [0, 0, '-20px'],
  href: '/guides/how-to-offramp-funds',
  colStart: ['auto']
}, {
  title: 'Try PayLeaf as a customer',
  subtitle: 'Learn how you can try PayLeaf in a quick and simple way',
  bgColor: '#2c326a',
  mt: [0, 0, '-80px'],
  href: '/guides/introduction-for-customers',
  colStart: [1, 'auto', 2]
}, {
  title: 'How does a PayLeaf payment work?',
  subtitle: `Learn what's happening behind the scenes`,
  bgColor: '#1981e8',
  mt: [],
  href: '/guides/how-a-payleaf-payment-works',
  colStart: [1, "auto", 3]
}, {
  title: 'Be a PayLeaf ambassador',
  subtitle: 'Learn how you can help to grow PayLeaf and profit off of that',
  bgColor: 'green',
  mt: [0, 0, '-20px'],
  href: '/guides/introduction-for-ambassadors',
  colStart: [1, "auto", 4]
}]

const PayLeafGuides = () => {
  const router = useRouter()

  return (
    <Box
      minHeight={'100vh'}
      background='#F3F3F5'
      color='#262626'
      display={'flex'}
      flexDirection='column'
      justifyContent={'space-between'}
    >
      <Container maxW={'78.5rem'} pt='2rem' px='1rem'>
      <PayLeafNavbar></PayLeafNavbar>

        <Grid mt='2rem' paddingX={[0, 0, 0, '5rem']} rowGap={'1.5rem'} columnGap={'1rem'} fontFamily={'Poppins'} templateColumns={['repeat(1, 1fr)', 'repeat(2, 1fr)', 'repeat(4, 3fr)']}>
          <GridItem colSpan={[1, 2, 2]}>
            <Heading fontFamily={'Qualy'}>
              Guides and resources
            </Heading>
            <Text mt='20px' opacity={0.8} fontWeight={500}>
              Explore and learn more about different aspects of PayLeaf - including the payment process, how to get started, offramping funds from your wallet to your bank account and more.
            </Text>
          </GridItem>
          {ALL_GUIDES.map(guide => (
            <GridItem
            key={guide.title} colStart={guide.colStart as any} colSpan={1}>
              <Box
                mt={guide.mt}
                borderRadius={'1rem'}
                minHeight={'17rem'}
                bg={guide.bgColor}
                maxWidth={'33rem'}
                paddingX={'2rem'}
                paddingY={'3rem'}
                cursor={'pointer'}
                transition='all .3s ease-in-out'
                boxShadow={'sm'}
                _hover={{
                  transform: 'translateY(-20px)',
                  boxShadow: 'lg',
                }}
                onClick={() => router.push(guide.href)}
              >
                <Text color='#fff' fontSize='.875rem' fontWeight={600} opacity={0.64}>
                  {guide.subtitle}
                </Text>
                <Text color='#fff'  mt='1rem' fontWeight={700} fontSize='1.5rem'>
                  {guide.title}
                </Text>
              </Box>
            </GridItem>
          ))}
        </Grid>
      </Container>
    </Box>
  )
}

export default PayLeafGuides
